import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check, ArrowRight, Mail } from "lucide-react";
import qcardLogo from "@/assets/qcard-logo-official.png";

const SignupConfirmation = () => {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      {/* Header */}
      <header className="py-6 border-b border-border">
        <div className="container mx-auto px-4">
          <Link to="/homepage-enterprise">
            <img src={qcardLogo} alt="QCard" className="h-10" />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center py-16 px-4">
        <div className="max-w-lg w-full text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-enterprise-purple/10 rounded-full flex items-center justify-center mx-auto mb-8">
            <Check className="w-10 h-10 text-enterprise-purple" />
          </div>

          {/* Thank You Message */}
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-foreground">
            Thank You for Signing Up!
          </h1>
          
          <p className="text-lg text-muted-foreground mb-8">
            We've received your information and are creating your personalized digital business card. 
            You'll receive an email at the address you provided once your profile has been successfully created.
          </p>

          {/* Email Notice */}
          <div className="bg-muted/50 rounded-xl p-6 mb-8 border border-border">
            <div className="flex items-center justify-center gap-3 mb-3">
              <Mail className="w-5 h-5 text-enterprise-purple" />
              <span className="font-semibold text-foreground">Check Your Inbox</span>
            </div>
            <p className="text-sm text-muted-foreground">
              We'll send you an email with your QCard link within 24-48 hours. 
              Be sure to check your spam folder if you don't see it.
            </p>
          </div>

          {/* What's Next */}
          <div className="text-left bg-card rounded-xl p-6 border border-border mb-8">
            <h3 className="font-semibold text-foreground mb-4">What happens next?</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-start gap-3">
                <span className="bg-enterprise-purple text-white rounded-full w-5 h-5 flex items-center justify-center text-xs flex-shrink-0 mt-0.5">1</span>
                <span>Our team will create your personalized QCard profile</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="bg-enterprise-purple text-white rounded-full w-5 h-5 flex items-center justify-center text-xs flex-shrink-0 mt-0.5">2</span>
                <span>You'll receive an email with your unique QCard link</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="bg-enterprise-purple text-white rounded-full w-5 h-5 flex items-center justify-center text-xs flex-shrink-0 mt-0.5">3</span>
                <span>Start sharing your digital business card instantly!</span>
              </li>
            </ul>
          </div>

          {/* Back to Home Button */}
          <Button 
            asChild
            className="bg-enterprise-purple hover:bg-enterprise-purple-dark text-white font-semibold px-8 py-6 rounded-full"
          >
            <Link to="/homepage-enterprise">
              Back to Home
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="py-6 border-t border-border">
        <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
          © {new Date().getFullYear()} QCard Enterprise. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default SignupConfirmation;
